///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/filter-interactive.ts"/>


module Meevo.Components.Controls.SmartMover {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export class ActiveInactiveFilter extends InteractiveFilter implements IInteractiveFilter {
        public readonly templateName: FilterTemplateNames;
        public readonly values: { hideInactive: boolean};
        public readonly labels: { hideInactiveLabel: string; };
        public readonly disabled: boolean;
        public model: any;
        public propertyName: any;

        constructor(labels: { hideInactiveLabel: string }, public dataTemplate: IDataTemplate = null, private showSelectedInactive = false, model?: any, propertyName?: string) {
            super({labels}, dataTemplate);

            this.templateName = 'active-inactive';
            this.values = {
                hideInactive: true
            };
            if (dataTemplate) {
                this.disabled = dataTemplate.disabled;
            }

            if (model && propertyName) {
                this.model = model;
                this.propertyName = propertyName;
                if (model[propertyName] == null) {
                    model[propertyName] = this.values.hideInactive;
                }
                else {
                    this.values.hideInactive = model[propertyName];
                }
            }
            
        }

        onFilterChange() {
            if (this.model && this.propertyName) {
                this.model[this.propertyName] = this.values.hideInactive;
            }
            this.emit('change');
        }
        
        filter(rows: ISmartMoverModel<any>[]): ISmartMoverModel<any>[] {
            return rows
                .filter(row => (this.showSelectedInactive && row.selected) || (this.values.hideInactive
                    && (
                        row.get('objectState') === ObjectStateEnum.Active
                        || row.get('objectStateEnum') === ObjectStateEnum.Active
                    ))
                    || !this.values.hideInactive)
        }
    }
}